// import "antd/dist/antd.css";

import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router";

import { AppLayout } from "./layout";
import { PageNotFound } from "./pages/page-not-found";
import { OrdinationsAndCountriesContextProvider } from "./contexts/ordinationsAndCountriesContext";

import { UserContextProvider } from "./contexts/userContext";

import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-WX5HTGV",
};

TagManager.initialize(tagManagerArgs);

export function App() {
  const [ordinationId, setOrdinationId] = useState(1);

  return (
    <UserContextProvider >
      <OrdinationsAndCountriesContextProvider>
				<BrowserRouter>
					<Routes>
						<Route
							exact
							path="/page-not-found"
							element={
								<PageNotFound
									from={
										window.history.state?.usr?.from
									}
								/>
							}
						/>
						<Route path="/*" element={<AppLayout />} />
					</Routes>
				</BrowserRouter>
      </OrdinationsAndCountriesContextProvider>
    </UserContextProvider>
  );
}

export default App;
